import React from 'react';
import { Group, Select, ActionIcon, TextInput } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { IconTrash } from '@tabler/icons-react';
import { LifeEvent, LifeEventTypes } from '../../../types/Person';
import '@mantine/dates/styles.css';

interface LifeEventListProps {
  lifeEvents: LifeEvent[];
  onUpdateLifeEvent: (index: number, field: keyof LifeEvent, value: any) => void;
  onRemoveLifeEvent: (index: number) => void;
  disabled?: boolean;
}

export const LifeEventList: React.FC<LifeEventListProps> = ({
  lifeEvents,
  onUpdateLifeEvent,
  onRemoveLifeEvent,
  disabled = false,
}) => {
  return (
    <>
      {lifeEvents.map((event, index) => (
        <Group key={index} align="flex-start" justify="space-between">
          <Select
            data={LifeEventTypes}
            value={event.type}
            onChange={(value) => onUpdateLifeEvent(index, 'type', value)}
            placeholder="Select event type"
            style={{ flex: 1 }}
            disabled={event.isLocked || disabled}
          />
          <DateInput
            value={event.date}
            onChange={(value) => onUpdateLifeEvent(index, 'date', value)}
            placeholder="Event date"
            style={{ flex: 1 }}
            disabled={event.isLocked || disabled}
          />
          <TextInput
            value={event.description || ''}
            onChange={(e) => onUpdateLifeEvent(index, 'description', e.currentTarget.value)}
            placeholder="notes"
            style={{ flex: 2 }}
            disabled={disabled}
          />
          {!event.isLocked && (
            <ActionIcon
              color="red"
              onClick={() => onRemoveLifeEvent(index)}
              variant="outline"
              disabled={disabled}
            >
              <IconTrash size={16} />
            </ActionIcon>
          )}
          {event.isLocked && (
            <ActionIcon
              color="white"
              onClick={() => {}}
              variant="white"
            >
              <IconTrash size={16} />
            </ActionIcon>
          )}
        </Group>
      ))}
    </>
  );
};
